export default __webpack_public_path__ + "static/media/PP-bg.dba05ced.png";